import { Icon, Surface, Txt } from '@vst/beam';
import styles from './selectedPlansName.module.scss';
import { PlanCharacteristics } from '@buy-viasat/types/build/bv';
import { SpeedOutlined } from '@vst/beam-icons/icons';

type FiberPlanCartHeaderProps = {
  name: string;
  characteristics: PlanCharacteristics | null;
};

export const FiberPlanCartHeader = ({ name, characteristics }: FiberPlanCartHeaderProps) => {
  const { fiberSpeedText, textGeneral01 } = characteristics ?? {};

  return (
    <Surface pb="24px" className={styles['planNameContainer']} data-testid="CheckoutCartSelectedPlanName">
      <Txt variant="heading5" data-testid="planName">
        {name}
      </Txt>
      <Txt variant="smallRegular" data-testid={'highSpeedData'} color={'subtle'}>
        {textGeneral01}
      </Txt>
      <Surface className={styles['downloadSpeedContainer']} data-testid="downloadSpeedContainer">
        <Icon icon={SpeedOutlined} mr="4px" color="black" data-testid="downloadSpeedIcon" />
        <Txt variant="tinyRegular" data-testid="downloadSpeedText" className={styles['bold']}>
          {fiberSpeedText}
        </Txt>
      </Surface>
    </Surface>
  );
};
